import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
// eslint-disable-next-line import/extensions
import enTranslation from './locales/en/translation.json';
// eslint-disable-next-line import/extensions
import enCommon from './locales/en/common.json';
// eslint-disable-next-line import/extensions
import enDashboard from './locales/en/dashboard.json';
// eslint-disable-next-line import/extensions
import enPeople from './locales/en/people.json';
// eslint-disable-next-line import/extensions
import enApplications from './locales/en/applications.json';
// eslint-disable-next-line import/extensions
import enAssets from './locales/en/assets.json';
// eslint-disable-next-line import/extensions
import enGettingStarted from './locales/en/getting-started.json';
// eslint-disable-next-line import/extensions
import enSecurity from './locales/en/security.json';
// eslint-disable-next-line import/extensions
import enAiChat from './locales/en/ai-chat.json';
// eslint-disable-next-line import/extensions
import enSupportCenter from './locales/en/support-center.json';
// eslint-disable-next-line import/extensions
import enPages from './locales/en/pages.json';
// eslint-disable-next-line import/extensions
import enMarketplace from './locales/en/marketplace.json';
// eslint-disable-next-line import/extensions
import enBilling from './locales/en/billing.json';
// eslint-disable-next-line import/extensions
import enCatalog from './locales/en/catalog.json';
// eslint-disable-next-line import/extensions
import enMdm from './locales/en/mdm.json';
// eslint-disable-next-line import/extensions
import enRequests from './locales/en/requests.json';
// eslint-disable-next-line import/extensions
import enSignup from './locales/en/signup.json';
// eslint-disable-next-line import/extensions
import enStorefront from './locales/en/storefront.json';
// eslint-disable-next-line import/extensions
import enComponents from './locales/en/components.json';
// eslint-disable-next-line import/extensions
import enItPlan from './locales/en/it-plan.json';
// eslint-disable-next-line import/extensions
import enGroups from './locales/en/groups.json';
// eslint-disable-next-line import/extensions
import enPlans from './locales/en/plans.json';
// eslint-disable-next-line import/extensions
import enCoreEntity from './locales/en/core-entity.json';
// eslint-disable-next-line import/extensions
import enSecrets from './locales/en/secrets.json';
// eslint-disable-next-line import/extensions
import enLeave from './locales/en/leave.json';
// eslint-disable-next-line import/extensions
import enCountries from './locales/en/countries.json';

// Import French Canadian translations
// eslint-disable-next-line import/extensions
import frCATranslation from './locales/fr-CA/translation.json';
// eslint-disable-next-line import/extensions
import frCACommon from './locales/fr-CA/common.json';
// eslint-disable-next-line import/extensions
import frCADashboard from './locales/fr-CA/dashboard.json';
// eslint-disable-next-line import/extensions
import frCAPeople from './locales/fr-CA/people.json';
// eslint-disable-next-line import/extensions
import frCAApplications from './locales/fr-CA/applications.json';
// eslint-disable-next-line import/extensions
import frCAAssets from './locales/fr-CA/assets.json';
// eslint-disable-next-line import/extensions
import frCAGettingStarted from './locales/fr-CA/getting-started.json';
// eslint-disable-next-line import/extensions
import frCASecurity from './locales/fr-CA/security.json';
// eslint-disable-next-line import/extensions
import frCAAiChat from './locales/fr-CA/ai-chat.json';
// eslint-disable-next-line import/extensions
import frCASupportCenter from './locales/fr-CA/support-center.json';
// eslint-disable-next-line import/extensions
import frCAPages from './locales/fr-CA/pages.json';
// eslint-disable-next-line import/extensions
import frCAMarketplace from './locales/fr-CA/marketplace.json';
// eslint-disable-next-line import/extensions
import frCABilling from './locales/fr-CA/billing.json';
// eslint-disable-next-line import/extensions
import frCACatalog from './locales/fr-CA/catalog.json';
// eslint-disable-next-line import/extensions
import frCAMdm from './locales/fr-CA/mdm.json';
// eslint-disable-next-line import/extensions
import frCARequests from './locales/fr-CA/requests.json';
// eslint-disable-next-line import/extensions
import frCASignup from './locales/fr-CA/signup.json';
// eslint-disable-next-line import/extensions
import frCAStorefront from './locales/fr-CA/storefront.json';
// eslint-disable-next-line import/extensions
import frCAComponents from './locales/fr-CA/components.json';
// eslint-disable-next-line import/extensions
import frCAItPlan from './locales/fr-CA/it-plan.json';
// eslint-disable-next-line import/extensions
import frCAGroups from './locales/fr-CA/groups.json';
// eslint-disable-next-line import/extensions
import frCAPlans from './locales/fr-CA/plans.json';
// eslint-disable-next-line import/extensions
import frCACoreEntity from './locales/fr-CA/core-entity.json';
// eslint-disable-next-line import/extensions
import frCASecrets from './locales/fr-CA/secrets.json';
// eslint-disable-next-line import/extensions
import frCALeave from './locales/fr-CA/leave.json';
// eslint-disable-next-line import/extensions
import frCACountries from './locales/fr-CA/countries.json';

// Import Spanish translations
// eslint-disable-next-line import/extensions
import esTranslation from './locales/es/translation.json';
// eslint-disable-next-line import/extensions
import esCommon from './locales/es/common.json';
// eslint-disable-next-line import/extensions
import esDashboard from './locales/es/dashboard.json';
// eslint-disable-next-line import/extensions
import esPeople from './locales/es/people.json';
// eslint-disable-next-line import/extensions
import esApplications from './locales/es/applications.json';
// eslint-disable-next-line import/extensions
import esAssets from './locales/es/assets.json';
// eslint-disable-next-line import/extensions
import esGettingStarted from './locales/es/getting-started.json';
// eslint-disable-next-line import/extensions
import esSecurity from './locales/es/security.json';
// eslint-disable-next-line import/extensions
import esAiChat from './locales/es/ai-chat.json';
// eslint-disable-next-line import/extensions
import esSupportCenter from './locales/es/support-center.json';
// eslint-disable-next-line import/extensions
import esPages from './locales/es/pages.json';
// eslint-disable-next-line import/extensions
import esMarketplace from './locales/es/marketplace.json';
// eslint-disable-next-line import/extensions
import esBilling from './locales/es/billing.json';
// eslint-disable-next-line import/extensions
import esCatalog from './locales/es/catalog.json';
// eslint-disable-next-line import/extensions
import esMdm from './locales/es/mdm.json';
// eslint-disable-next-line import/extensions
import esRequests from './locales/es/requests.json';
// eslint-disable-next-line import/extensions
import esSignup from './locales/es/signup.json';
// eslint-disable-next-line import/extensions
import esStorefront from './locales/es/storefront.json';
// eslint-disable-next-line import/extensions
import esComponents from './locales/es/components.json';
// eslint-disable-next-line import/extensions
import esItPlan from './locales/es/it-plan.json';
// eslint-disable-next-line import/extensions
import esGroups from './locales/es/groups.json';
// eslint-disable-next-line import/extensions
import esPlans from './locales/es/plans.json';
// eslint-disable-next-line import/extensions
import esCoreEntity from './locales/es/core-entity.json';
// eslint-disable-next-line import/extensions
import esSecrets from './locales/es/secrets.json';
// eslint-disable-next-line import/extensions
import esLeave from './locales/es/leave.json';
// eslint-disable-next-line import/extensions
import esCountries from './locales/es/countries.json';

// Initialize i18n with LanguageDetector by default
// This will be conditionally controlled based on the itHubI18N flag
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        common: enCommon,
        dashboard: enDashboard,
        people: enPeople,
        applications: enApplications,
        assets: enAssets,
        'getting-started': enGettingStarted,
        security: enSecurity,
        'ai-chat': enAiChat,
        'support-center': enSupportCenter,
        pages: enPages,
        marketplace: enMarketplace,
        billing: enBilling,
        catalog: enCatalog,
        mdm: enMdm,
        requests: enRequests,
        signup: enSignup,
        storefront: enStorefront,
        components: enComponents,
        'it-plan': enItPlan,
        groups: enGroups,
        plans: enPlans,
        'core-entity': enCoreEntity,
        secrets: enSecrets,
        leave: enLeave,
        countries: enCountries,
      },
      'fr-CA': {
        translation: frCATranslation,
        common: frCACommon,
        dashboard: frCADashboard,
        people: frCAPeople,
        applications: frCAApplications,
        assets: frCAAssets,
        'getting-started': frCAGettingStarted,
        security: frCASecurity,
        'ai-chat': frCAAiChat,
        'support-center': frCASupportCenter,
        pages: frCAPages,
        marketplace: frCAMarketplace,
        billing: frCABilling,
        catalog: frCACatalog,
        mdm: frCAMdm,
        requests: frCARequests,
        signup: frCASignup,
        storefront: frCAStorefront,
        components: frCAComponents,
        'it-plan': frCAItPlan,
        groups: frCAGroups,
        plans: frCAPlans,
        'core-entity': frCACoreEntity,
        secrets: frCASecrets,
        leave: frCALeave,
        countries: frCACountries,
      },
      es: {
        translation: esTranslation,
        common: esCommon,
        dashboard: esDashboard,
        people: esPeople,
        applications: esApplications,
        assets: esAssets,
        'getting-started': esGettingStarted,
        security: esSecurity,
        'ai-chat': esAiChat,
        'support-center': esSupportCenter,
        pages: esPages,
        marketplace: esMarketplace,
        billing: esBilling,
        catalog: esCatalog,
        mdm: esMdm,
        requests: esRequests,
        signup: esSignup,
        storefront: esStorefront,
        components: esComponents,
        'it-plan': esItPlan,
        groups: esGroups,
        plans: esPlans,
        'core-entity': esCoreEntity,
        secrets: esSecrets,
        leave: esLeave,
        countries: esCountries,
      },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    // Add debug for development
    debug: import.meta.env.DEV,
  });

export default i18n;
